export enum NotificationCategory {
  GENERAL = "GENERAL",
  ACADEMIC = "ACADEMIC",
  BILLING = "BILLING",
  PROMITION = "PROMOTION",
  EVENTS = "EVENTS",
}
